/** Vrai dès le clic sur déconnexion, avant la fin de l’appel réseau. Bloque un refresh qui recréerait la session. */
let clientLogoutInProgress = false;

export function beginClientLogout(): void {
  clientLogoutInProgress = true;
}

export function isClientLogoutInProgress(): boolean {
  return clientLogoutInProgress;
}

export function clearClientLogout(): void {
  clientLogoutInProgress = false;
}

/**
 * Supprime un éventuel cookie `auth_token` accessible au JS lorsque le SPA a déjà
 * un jeton en localStorage. Évite une désynchronisation avec l’API (Bearer = bon compte,
 * cookie résiduel = autre compte) avant correction serveur ou sur anciens déploiements.
 */
export function clearStaleAuthTokenCookie(): void {
  if (typeof document === 'undefined') return;
  if (!localStorage.getItem('auth_token')) return;
  clearAuthCookiesBestEffort();
}

/** Invalide côté navigateur les cookies de session que le JS peut toucher (pas httpOnly). */
function clearAuthCookiesBestEffort(): void {
  if (typeof document === 'undefined') return;
  const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
  const names = ['auth_token', 'refreshToken'];
  for (const name of names) {
    document.cookie = `${name}=; expires=${expires}; path=/`;
    document.cookie = `${name}=; expires=${expires}; path=/; Secure`;
  }
}

/**
 * Jetons + entrée persist Zustand auth + sessionStorage + cookies JS.
 * À utiliser sur 401 ou après déconnexion locale, sans tout effacer (ex. préférences UI).
 */
export function purgeAuthTokensAndPersist(): void {
  try {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_refresh_token');
    localStorage.removeItem('auth_user');
    localStorage.removeItem('auth-storage');
    sessionStorage.clear();
  } catch {
    /* storage indisponible */
  }
  clearAuthCookiesBestEffort();
}

const USER_SCOPED_LS_KEYS = [
  'lyrra_recent_searches',
  'institution_block_templates',
  'institution_categories',
  'lyrra-sounds-tags',
  'lyrra-clipboard',
] as const;

/**
 * Nettoyage complet à la déconnexion : plus de trace locale de session ni de données
 * évidentes liées au compte (parcours joueur, brouillons, recherches, etc.).
 */
export function purgeClientSessionOnLogout(): void {
  purgeAuthTokensAndPersist();
  try {
    for (const k of USER_SCOPED_LS_KEYS) {
      localStorage.removeItem(k);
    }
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (key.startsWith('eduflow-player-') || key.startsWith('draft-')) {
        toRemove.push(key);
      }
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
  } catch {
    /* ignore */
  }
}
